module.exports = __webpack_public_path__ + "static/media/Calibri-01.c99897ee.svg";